<template>
  <div>
    <head-nav-bar
      title="房态管理"
      right-text="筛选"
      left-arrow
      :fixed="true"
      @click-left="$router.push({ name: 'workplace' })"
      @click-right="screen"
    />
    <div class="mt-header-nav">
      <van-search
        placeholder="房号/客人姓名/手机号/备注"
        v-model="searchData.keyWords"
        @search="onSearch"
        show-action
        shape="round"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div id="forward">
        <!-- 头部日历 -->
        <div
          class="main-header scroll-hidden"
          ref="mainHeader"
          @scroll="headerScroll"
          @touchstart="forwardMouseenter('header')"
        >
          <table>
            <tr>
              <td class="slider-td"></td>
              <td v-for="(item, index) in roomData.CalendarOutput" :key="index">
                <div
                  :class="{
                    isWeekend: item.DayOfWeek == '6' || item.DayOfWeek == '0',
                    istoday: isAccountDate(item.FullDate),
                  }"
                >
                  <p>
                    {{ isAccountDate(item.FullDate) ? "今天" : item.Date }}
                    {{ item.Week.charAt(item.Week.length - 1) }}
                  </p>
                  <span class="r-count"
                    >{{
                      availableQuantityObj &&
                      availableQuantityObj[item.FullDate]
                        ? Number(
                            availableQuantityObj[item.FullDate]
                              .AvailableQuantity || 0,
                          )
                        : Number(item.AvailableQuantity)
                    }}间</span
                  >
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div
          class="main-content scroll-hidden"
          ref="mainContent"
          @scroll="mainScroll"
          @touchstart="forwardMouseenter('main')"
        >
          <table>
            <tr v-for="(item, index) in roomData.RoomNoStatuses" :key="index">
              <td class="slider-td"></td>
              <td
                v-for="(dItem, dIndex) in roomData.CalendarOutput"
                :key="dIndex"
              >
                <!-- 空房状态 -->
                <div
                  class="empty"
                  :data-date="dItem.FullDate"
                  :data-no="item.No"
                  :data-roomid="item.Id"
                  :data-roomname="item.RoomTypeName"
                  :data-roomTypeId="item.RoomTypeId"
                  @click="emptyChecked($event, index, dIndex, item, dItem)"
                >
                  <van-icon name="passed" />
                </div>
                <template v-for="(rItem, rIndex) in item.roomStatusCalendar">
                  <!-- 维修 -->
                  <div
                    v-if="
                      rItem.FullDate === dItem.FullDate &&
                        (rItem.RoomStatus === 2 || rItem.RoomStatus === 3) &&
                        rItem.isShowInfo
                    "
                    class="room-item"
                    :style="rItem.styleOption"
                    :key="rIndex"
                    @click="setRepairEnd(item, rItem)"
                  >
                    <div class="repair-txt">
                      {{ rItem.RepairStatusName }}
                    </div>
                    <div style="color:#fff;padding-left:0.1rem">
                      {{ rItem.RepairReason }}
                    </div>
                  </div>
                  <template
                    v-for="(gItem, gIndex) in rItem.CalendarGuestDetails"
                  >
                    <div
                      class="room-item"
                      :data-detailId="gItem.OrderDetailId"
                      :data-status="gItem.OrderStatus"
                      :data-day="
                        moment(gItem.CheckOutDate).diff(
                          moment(gItem.CheckInDate),
                          'days',
                        )
                      "
                      :style="gItem.styleOption"
                      :key="gIndex"
                      v-if="
                        rItem.FullDate === dItem.FullDate && gItem.isShowInfo
                      "
                      @click="checkDetail(gItem)"
                    >
                      <div class="inner">
                        {{ gItem.GuestName }}
                        <span
                          class="is-checking is-status-checking"
                          v-if="gItem.IsChecking"
                          >查</span
                        >
                      </div>
                      <span style="position: absolute; bottom: 0; right: 2px;">
                        <van-icon
                          v-if="gItem.HasContacted"
                          name="friends-o"
                          size="15px"
                        />
                        <van-icon
                          v-if="gItem.IsHourRoom"
                          name="clock-o"
                          size="15px"
                        />
                      </span>
                      <p class="tag-list">
                        <van-tag class="tag" v-if="gItem.MemberCardNo">{{
                          defaultItem.Member ? defaultItem.Member : "卡"
                        }}</van-tag>
                        <van-tag class="tag" v-if="gItem.CustomerName">{{
                          defaultItem.Customer ? defaultItem.Customer : "客"
                        }}</van-tag>
                        <van-tag class="tag" v-if="gItem.ChanelName">{{
                          defaultItem.Channel
                            ? defaultItem.Channel
                            : gItem.ChanelName.slice(0, 1)
                        }}</van-tag>
                      </p>
                    </div>
                  </template>
                </template>
                <!--end 空房状态 -->
              </td>
            </tr>
          </table>
        </div>
        <!-- 左侧栏房型房号 -->
        <div class="fixed-left">
          <div class="fixed-header">
            <table>
              <tr>
                <td>
                  <p>账务日期</p>
                  <p>{{ user.AccountDate }}</p>
                </td>
              </tr>
            </table>
          </div>
          <div class="outer-container">
            <div
              class="fixed-content scroll-hidden"
              ref="fixedContent"
              @touchstart="forwardMouseenter('fixed')"
              @scroll="fixedScroll"
            >
              <table>
                <tr
                  v-for="(item, index) in roomData.RoomNoStatuses"
                  :key="index"
                  class="long"
                  v-longpress="e => roomSetting(item)"
                  @click="checkRoomLog(item.Id)"
                >
                  <td class="room-no" :style="{ backgroundColor: item.Color }">
                    <p class="roomtype-name">{{ item.RoomTypeName }}</p>
                    <p>{{ item.No }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <van-icon name="replay" class="replay" @click.stop.prevent="reflesh" />
      <div class="operation">
        <van-button type="default" @click="clearDate">取消选中</van-button>
        <van-button
          type="primary"
          :disabled="disabled.reserve"
          @click="roomOrder('order', 1)"
          >预定</van-button
        >
        <van-button
          type="info"
          :disabled="disabled.checkIn"
          @click="roomOrder('checkin', 1)"
          >入住</van-button
        >
      </div>
      <roomUpdate
        ref="roomUpdate"
        :visible.sync="visible.roomUpdate"
        :option="roomInfo"
        fromUrl="RoomStatus"
        :defaultItem="defaultItem"
        @update="getRoomData"
      ></roomUpdate>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { Icon, NavBar, Button, Search, Toast, Tag, Dialog } from "vant";
import RoomUpdate from "./roomComponent/RoomUpdate.vue";
import arrowRight from "@/assets/images/arrow-right.png";
import roomApi from "@/api/room";
import { mixin } from "./mixin";
import cloneDeep from "lodash/cloneDeep";
export default {
  components: {
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Search.name]: Search,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog,
    RoomUpdate,
  },
  mixins: [mixin],
  data() {
    return {
      arrowRight,
      moment,
      loading: false,
      roomData: {
        CalendarOutput: [],
        RoomNoStatuses: [],
      },
      disabled: {
        reserve: true,
        checkIn: true,
      },
      roomInfo: {},
      baseData: [],
      availableQuantityObj: null,
    };
  },
  computed: {
    isAccountDate() {
      return function(val) {
        return val == moment(this.user.AccountDate).format("YYYY-MM-DD");
      };
    },
  },
  mounted() {
    let AccountDate = this.user.AccountDate;
    this.searchData.startDate = moment(AccountDate)
      .subtract(2, "d")
      .format("YYYY-MM-DD");
    this.searchData.endDate = moment(AccountDate)
      .add(7, "d")
      .format("YYYY-MM-DD");
    this.getSearchSelectData();
    this.getRoomData();
    this.getDefaultItem();
  },
  methods: {
    /**关键字搜索 */
    onSearch() {
      const keyWords = this.searchData.keyWords.trim();
      const roomType = this.searchData.roomType;
      const data = cloneDeep(this.baseData);
      if (!keyWords && !roomType) {
        this.roomData.RoomNoStatuses = data;
        this.countAvailableQuantity();
        return;
      }
      let list = [],
        ids = [];
      data.forEach(el => {
        let isPush = true;
        if (roomType && el.RoomTypeId != roomType) {
          isPush = false;
        }
        if (isPush && keyWords) {
          if (el.No.includes(keyWords)) {
            list.push(el);
            ids.push(el.Id);
          } else if (el.roomStatusCalendar && el.roomStatusCalendar.length) {
            for (let i = 0; i < el.roomStatusCalendar.length; i++) {
              const item = el.roomStatusCalendar[i];
              (item.CalendarGuestDetails || []).forEach(p => {
                if (p.isShowInfo) {
                  if (
                    ((p.GuestName || "").includes(keyWords) ||
                      (p.Phone || "").includes(keyWords) ||
                      (p.Remark || "").includes(keyWords)) &&
                    !ids.includes(el.Id)
                  ) {
                    list.push(el);
                    ids.push(el.Id);
                  }
                }
              });
            }
          }
        } else if (!keyWords && isPush) {
          list.push(el);
          ids.push(el.Id);
        }
      });
      this.roomData.RoomNoStatuses = list;
      this.countAvailableQuantity();
    },
    countAvailableQuantity() {
      let dateObj = {},
        len = this.roomData.RoomNoStatuses.length;
      this.roomData.CalendarOutput.forEach(el => {
        let availableQuantity = len;
        this.roomData.RoomNoStatuses.forEach(item => {
          if (
            item.RoomStatusCalendarOutputs &&
            item.RoomStatusCalendarOutputs.length
          ) {
            item.RoomStatusCalendarOutputs.forEach(p => {
              if (
                (p.RoomStatus == 2 || p.RoomStatus == 3) &&
                moment(el.FullDate).isBetween(
                  p.RepairBeginTime,
                  p.RepairEndTime,
                  null,
                  "[)",
                )
              ) {
                availableQuantity--;
              }
              (p.CalendarGuestDetails || []).forEach(o => {
                if (
                  moment(el.FullDate).isBetween(
                    o.CheckInDate,
                    o.CheckOutDate,
                    null,
                    "[)",
                  )
                ) {
                  availableQuantity--;
                }
              });
            });
          }
        });
        if (!dateObj[el.FullDate]) {
          dateObj[el.FullDate] = {
            AvailableQuantity: availableQuantity,
          };
        }
      });
      this.availableQuantityObj = dateObj;
    },
    /**获取房态信息*/
    getRoomData(callback) {
      this.loading = true;
      this.clearDate();
      const json = {
        StartDate: this.searchData.startDate,
        EndDate: this.searchData.endDate,
        // RoomTypeId: this.searchData.roomType,
        RoomStatusType: this.searchData.roomStatus,
        SortModel: this.searchData.sortModel,
      };
      // if (this.searchData.keyWords && this.searchData.keyWords.trim()) {
      //   json.KeyWords = this.searchData.keyWords.trim();
      // }
      roomApi
        .GetRoomStatus(json)
        .then(res => {
          this.roomData.CalendarOutput = res.Data.CalendarOutput;
          this.roomData.RoomNoStatuses = res.Data.RoomNoStatuses;
          this.roomData.RoomNoStatuses.forEach(element => {
            element.roomStatusCalendar = element.RoomStatusCalendarOutputs.map(
              v => {
                let fullDate = v.FullDate;
                if (v.RoomStatus === 2 || v.RoomStatus === 3) {
                  //维修状态
                  this.showDetail(
                    v,
                    v.RepairBeginTime,
                    v.RepairEndTime,
                    fullDate,
                  );
                } else {
                  if (
                    v.CalendarGuestDetails &&
                    v.CalendarGuestDetails.length > 1
                  ) {
                    v.CalendarGuestDetails = v.CalendarGuestDetails.filter(
                      (item, index) => index == 0,
                    );
                  }
                  v.CalendarGuestDetails.map(item => {
                    let CheckInDate = item.CheckInDate;
                    let CheckOutDate = item.CheckOutDate;
                    this.showDetail(item, CheckInDate, CheckOutDate, fullDate);
                  });
                }
                return v;
              },
            );
          });
          this.loading = false;
          this.baseData = cloneDeep(this.roomData.RoomNoStatuses);
          callback && callback();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showDetail(item, startTime, endTime, fullDate) {
      let startDate = moment(startTime).format("YYYY-MM-DD");
      let endDate = moment(endTime).format("YYYY-MM-DD");
      let endDateTime = endTime;
      if (startDate == endDate) {
        endDateTime = moment(endDate)
          .add(1, "d")
          .format("YYYY-MM-DD");
      }
      let hours = moment(endDateTime).diff(moment(startTime), "hours");
      let sep = Math.ceil(hours / 24) - 1;
      let styleOption = {
        backgroundColor: item.CustomColor ? item.CustomColor : item.Color,
      };
      item.styleOption = styleOption;
      if (startDate === fullDate && hours > 0) {
        let startHour = moment(startTime).hour();
        item.styleOption.left = (startHour / 24) * 100 + "%";
        item.styleOption.width =
          "calc(" + (hours / 24) * 100 + "% + " + sep + "px)";
        item.isShowInfo = true;
      } else if (moment(fullDate).isAfter(startDate)) {
        hours = moment(endDateTime).diff(moment(fullDate), "hours");
        if (hours > 0) {
          sep = Math.ceil(hours / 24) - 1;
          item.styleOption.left = 0;
          item.styleOption.width =
            "calc(" + (hours / 24) * 100 + "% + " + sep + "px)";
          item.isShowInfo = true;
        } else {
          item.isShowInfo = false;
        }
      } else {
        item.isShowInfo = false;
      }
    },
    setRepairEnd(item, rItem) {
      if (rItem.RoomStatus == 2) {
        Dialog.confirm({
          message: "确定解除维修吗？",
        })
          .then(() => {
            this.$refs.roomUpdate.setUnRepair(item.Id, item.No, [
              moment(rItem.RepairBeginTime).format("YYYY-MM-DD"),
              moment(rItem.RepairEndTime).format("YYYY-MM-DD"),
            ]);
          })
          .catch(() => {
            // on cancel
          });
      } else if (rItem.RoomStatus == 3) {
        Dialog.confirm({
          message: "确定解除封房吗？",
        })
          .then(() => {
            this.$refs.roomUpdate.cancelLock(item.Id, item.No, [
              moment(rItem.RepairBeginTime).format("YYYY-MM-DD"),
              moment(rItem.RepairEndTime).format("YYYY-MM-DD"),
            ]);
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    //获取系统参数值
    // getDefaultItem() {
    //   GetDefaultItem({}).then(res => {
    //     res.Data.SystemConstList.forEach(item => {
    //       this.defaultItem[item.Code] = item.Value;
    //     });
    //     res.Data.TimeList.forEach(item => {
    //       this.defaultItem[item.Code] = item.Value;
    //     });
    //   });
    // },
    //筛选
    screen() {
      this.getSearchPopup(1);
    },
    //搜索
    handleSearch(values) {
      if (values.date) {
        this.searchData.startDate = values.date[0];
        this.searchData.endDate = values.date[1];
      } else {
        let AccountDate = this.user.AccountDate;
        this.searchData.startDate = moment(AccountDate)
          .subtract(1, "d")
          .format("YYYY-MM-DD");
        this.searchData.endDate = moment(AccountDate)
          .add(7, "d")
          .format("YYYY-MM-DD");
      }
      this.setSearchValue(values);
    },
    reflesh() {
      this.clearDate();
      let AccountDate = this.user.AccountDate;
      this.searchData.startDate = moment(AccountDate)
        .subtract(2, "d")
        .format("YYYY-MM-DD");
      this.searchData.endDate = moment(AccountDate)
        .add(7, "d")
        .format("YYYY-MM-DD");
      this.getRoomData();
    },
    //空房选中
    emptyChecked(e, rowIndex, columnIndex, item) {
      let now = moment(this.user.AccountDate).format("YYYY-MM-DD");
      // 如果小于今天的日期或者停用房型，则不可预订和开房
      const isBefore = moment(
        e.currentTarget.dataset.date,
        "YYYY-MM-DD",
      ).isBefore(now);
      const attributes = this.defaultItem.RoomControlAttr;
      const canCheck = (attributes | 16) == attributes || !isBefore;
      if (item.ColorExplain == "停用" || !canCheck) {
        return;
      }
      if (this.$common.hasClass(e.currentTarget, "room-checked")) {
        this.$common.removeClass(e.currentTarget, "room-checked");
      } else {
        this.$common.addClass(e.currentTarget, "room-checked");
      }
      let roomCheckedObj = this.$refs.mainContent.querySelectorAll(
        ".room-checked",
      );
      let roomCheckedArr = [...roomCheckedObj];
      var result = [];
      roomCheckedArr.forEach(function(v, i) {
        const now = v.dataset.date;
        const typeId = v.dataset.roomtypeid;
        const roomname = v.dataset.roomname;
        const roomId = v.dataset.roomid;
        const roomNo = v.dataset.no;
        var temp = result[result.length - 1] && result[result.length - 1].date;
        const prevDate = i >= 1 ? roomCheckedArr[i - 1].dataset.date : now;
        const obj = {
          date: [now],
          roomId: roomId,
          roomNo: roomNo,
          roomTypeId: typeId,
          roomTypeName: roomname,
        };
        if (!i) {
          result.push(obj);
        } else if (
          moment(prevDate)
            .add(1, "d")
            .format("YYYY-MM-DD") === now &&
          result[result.length - 1].roomId === roomId
        ) {
          temp.push(now);
        } else {
          result.push(obj);
        }
      });
      this.checkedDateArray = result;
      var flag = roomCheckedObj.length ? false : true;
      this.disabled.checkIn = flag
        ? flag
        : this.checkedDateArray.some(item => {
            return (
              item.date[0] !== now &&
              moment(item.date[0], "YYYY-MM-DD").isAfter(now)
            );
          });
      this.disabled.reserve = flag;
    },
    headerScroll(e) {
      if (this.mouseType == "header") {
        this.$refs.mainContent.scrollLeft = e.currentTarget.scrollLeft;
      }
    },
    fixedScroll(e) {
      if (this.mouseType == "fixed") {
        this.$refs.mainContent.scrollTop = e.currentTarget.scrollTop;
      }
    },
    mainScroll(e) {
      if (this.mouseType == "main") {
        this.$refs.fixedContent.scrollTop = e.currentTarget.scrollTop;
        this.$refs.mainHeader.scrollLeft = e.currentTarget.scrollLeft;
      }
    },
    forwardMouseenter(type) {
      this.mouseType = type;
    },
  },
};
</script>
<style lang="less" scoped>
@import "./roomStatus.less";

.is-status-checking {
  top: 2px;
  position: absolute;
  right: 2px;
}
.is-checking {
  height: 18px;
  width: 18px;
  line-height: 16px;
  border-radius: 100%;
  background: #fff;
  text-align: center;
  font-size: 12px;
  border: 1px solid #f5222d;
  opacity: 0.7;
  color: #f5222d;
  z-index: 10;
  display: inline-block;
}
</style>
